import { createAction } from '@ngrx/store';

export const canActivate = createAction('[Active Legal Entity Guard] Can Activate');
